// Small per-device preferences shown in Profile → Settings. Each is remembered in this
// browser only; if storage is blocked the choice still applies for this visit.
export type TextSize = 'small' | 'normal' | 'large';
const KEYS = { textSize: 'utage.textSize', sound: 'utage.sound', vibration: 'utage.vibration' } as const;
const read = (key: string): string | null => { try { return localStorage.getItem(key); } catch { return null; } };
const write = (key: string, value: string): void => { try { localStorage.setItem(key, value); } catch { /* blocked storage */ } };

let textSize: TextSize = 'normal';
let sound = true;
let vibration = true;

const applyTextSize = (size: TextSize): void => { textSize = size; document.documentElement.dataset.textSize = size; };

export const getTextSize = (): TextSize => textSize;
export const setTextSize = (size: TextSize): void => { write(KEYS.textSize, size); applyTextSize(size); };
export const soundEnabled = (): boolean => sound;
export const setSoundEnabled = (on: boolean): void => { sound = on; write(KEYS.sound, on ? 'on' : 'off'); };
export const vibrationEnabled = (): boolean => vibration;
export const setVibrationEnabled = (on: boolean): void => { vibration = on; write(KEYS.vibration, on ? 'on' : 'off'); };

export const restoreSettings = (): void => {
  const stored = read(KEYS.textSize);
  applyTextSize(stored === 'small' || stored === 'large' ? stored : 'normal');
  sound = read(KEYS.sound) !== 'off';
  vibration = read(KEYS.vibration) !== 'off';
};
